var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path3, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path5, _path6, _rect18, _rect19, _rect20, _rect21, _rect22, _mask, _path7, _path8, _rect23, _rect24, _rect25, _rect26, _rect27, _circle, _circle2, _circle3, _circle4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectProdcutSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 210,
    viewBox: "0 0 111 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.414776,
    y: 0.414776,
    width: 109.883,
    height: 208.581,
    rx: 20.324,
    fill: "white",
    stroke: "#414554",
    strokeWidth: 0.829552
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.19965,
    y: 51.1997,
    width: 96.6582,
    height: 36.3467,
    rx: 1.79736,
    fill: "white",
    stroke: "#414554",
    strokeWidth: 0.399414
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7245,
    y: 54.978,
    width: 40.3408,
    height: 29.1572,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5248 54.978L99.265 84.335",
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7245 84.335L99.0653 54.978",
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3896,
    y: 58.7896,
    width: 29.5566,
    height: 2.7959,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 63.582,
    width: 29.5566,
    height: 2.7959,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 68.3745,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 70.772,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 73.1689,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.19965,
    y: 94.2002,
    width: 96.6582,
    height: 36.3467,
    rx: 1.79736,
    fill: "white",
    stroke: "#414554",
    strokeWidth: 0.399414
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7245,
    y: 97.978,
    width: 40.3408,
    height: 29.1572,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5248 97.978L99.265 127.335",
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7245 127.335L99.0653 97.978",
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3896,
    y: 101.79,
    width: 29.5566,
    height: 2.7959,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 106.583,
    width: 29.5566,
    height: 2.7959,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 111.376,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 113.771,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3893,
    y: 116.168,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 7.19965,
    y: 137.2,
    width: 96.6582,
    height: 36.3467,
    rx: 1.79736,
    fill: "white",
    stroke: "#414554",
    strokeWidth: 0.399414
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 58.7245,
    y: 140.978,
    width: 40.3408,
    height: 29.1572,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5248 140.978L99.265 170.335",
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7245 170.335L99.0653 140.978",
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3902,
    y: 144.79,
    width: 29.5566,
    height: 2.7959,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3901,
    y: 149.582,
    width: 29.5566,
    height: 2.7959,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3901,
    y: 154.376,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3901,
    y: 156.772,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3901,
    y: 159.168,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-1_1645_810",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.999786 19H110V46H0.999786V19Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999786 19H110V46H0.999786V19Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999786 19.3994H110V18.6006H0.999786V19.3994ZM110 45.6006H0.999786V46.3994H110V45.6006Z",
    fill: "#414554",
    mask: "url(#path-29-inside-1_1645_810)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6658,
    y: 24.8867,
    width: 17.8507,
    height: 1.25969,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6659,
    y: 28.2046,
    width: 31.1236,
    height: 3.74835,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6658,
    y: 41.478,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0382,
    y: 41.478,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4106,
    y: 41.478,
    width: 23.166,
    height: 1.19824,
    stroke: "#404041",
    strokeWidth: 0.399414
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1068,
    cy: 114.098,
    r: 4.76024,
    stroke: "#414554",
    strokeWidth: 0.829552
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1068,
    cy: 114.099,
    r: 6.8759,
    stroke: "#414554",
    strokeWidth: 0.829552
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1073,
    cy: 114.099,
    r: 8.99157,
    stroke: "#414554",
    strokeWidth: 0.829552
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.1074,
    cy: 114.098,
    r: 11.1072,
    stroke: "#414554",
    strokeWidth: 0.829552
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1645_810)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-40-outside-2_1645_810",
    maskUnits: "userSpaceOnUse",
    x: 44.2322,
    y: 111.513,
    width: 26,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 44.2322,
    y: 111.513,
    width: 26,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2573 112.513C51.9428 112.513 50.8772 113.579 50.8772 114.893V126.968L50.8634 126.928C50.4354 125.685 49.0809 125.024 47.8381 125.452C46.5952 125.88 45.9345 127.235 46.3625 128.477L50.1509 139.48C50.2034 139.632 50.27 139.776 50.3486 139.91C50.429 144.656 54.3013 148.479 59.0664 148.479C64.1828 148.479 68.3304 144.331 68.3304 139.215V135.891C68.3304 135.867 68.3303 135.843 68.33 135.82C68.3302 135.808 68.3303 135.796 68.3303 135.785V128.38C68.3303 127.212 67.3831 126.264 66.2146 126.264C65.0624 126.264 64.1253 127.185 64.0995 128.331V126.794C64.0995 125.625 63.1523 124.678 61.9839 124.678C60.8154 124.678 59.8682 125.625 59.8682 126.794V129.967H59.8672V125.206C59.8672 124.038 58.92 123.091 57.7516 123.091C56.6106 123.091 55.6806 123.994 55.6375 125.124V114.893C55.6375 113.579 54.5718 112.513 53.2573 112.513Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2573 112.513C51.9428 112.513 50.8772 113.579 50.8772 114.893V126.968L50.8634 126.928C50.4354 125.685 49.0809 125.024 47.8381 125.452C46.5952 125.88 45.9345 127.235 46.3625 128.477L50.1509 139.48C50.2034 139.632 50.27 139.776 50.3486 139.91C50.429 144.656 54.3013 148.479 59.0664 148.479C64.1828 148.479 68.3304 144.331 68.3304 139.215V135.891C68.3304 135.867 68.3303 135.843 68.33 135.82C68.3302 135.808 68.3303 135.796 68.3303 135.785V128.38C68.3303 127.212 67.3831 126.264 66.2146 126.264C65.0624 126.264 64.1253 127.185 64.0995 128.331V126.794C64.0995 125.625 63.1523 124.678 61.9839 124.678C60.8154 124.678 59.8682 125.625 59.8682 126.794V129.967H59.8672V125.206C59.8672 124.038 58.92 123.091 57.7516 123.091C56.6106 123.091 55.6806 123.994 55.6375 125.124V114.893C55.6375 113.579 54.5718 112.513 53.2573 112.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8772 126.968L49.9317 127.293L51.8772 126.968H50.8772ZM50.8634 126.928L49.9179 127.253L49.9179 127.253L50.8634 126.928ZM47.8381 125.452L47.5125 124.507H47.5125L47.8381 125.452ZM46.3625 128.477L45.417 128.803L45.417 128.803L46.3625 128.477ZM50.1509 139.48L51.0964 139.154L51.0964 139.154L50.1509 139.48ZM50.3486 139.91L51.3484 139.893L51.344 139.631L51.2114 139.405L50.3486 139.91ZM68.33 135.82L67.3301 135.803L67.3299 135.817L67.3301 135.831L68.33 135.82ZM64.0995 128.331H63.0995L65.0993 128.354L64.0995 128.331ZM59.8682 129.967V130.967H60.8682V129.967H59.8682ZM59.8672 129.967H58.8672V130.967H59.8672V129.967ZM55.6375 125.124H54.6375L56.6367 125.162L55.6375 125.124ZM51.8772 114.893C51.8772 114.131 52.4951 113.513 53.2573 113.513V111.513C51.3905 111.513 49.8772 113.027 49.8772 114.893H51.8772ZM51.8772 126.968V114.893H49.8772V126.968H51.8772ZM49.9179 127.253L49.9317 127.293L51.8227 126.642L51.8089 126.602L49.9179 127.253ZM48.1636 126.398C48.8843 126.149 49.6697 126.533 49.9179 127.253L51.8089 126.602C51.2011 124.837 49.2776 123.899 47.5125 124.507L48.1636 126.398ZM47.308 128.152C47.0599 127.431 47.4429 126.646 48.1636 126.398L47.5125 124.507C45.7474 125.114 44.8092 127.038 45.417 128.803L47.308 128.152ZM51.0964 139.154L47.308 128.152L45.417 128.803L49.2053 139.805L51.0964 139.154ZM51.2114 139.405C51.1661 139.327 51.1273 139.244 51.0964 139.154L49.2053 139.805C49.2796 140.021 49.3739 140.225 49.4858 140.416L51.2114 139.405ZM59.0664 147.479C54.8479 147.479 51.4196 144.095 51.3484 139.893L49.3487 139.927C49.4383 145.218 53.7547 149.479 59.0664 149.479V147.479ZM67.3304 139.215C67.3304 143.779 63.6305 147.479 59.0664 147.479V149.479C64.7351 149.479 69.3304 144.883 69.3304 139.215H67.3304ZM67.3304 135.891V139.215H69.3304V135.891H67.3304ZM67.3301 135.831C67.3303 135.851 67.3304 135.871 67.3304 135.891H69.3304C69.3304 135.863 69.3303 135.835 69.3299 135.808L67.3301 135.831ZM67.3303 135.785C67.3303 135.791 67.3302 135.797 67.3301 135.803L69.3299 135.836C69.3302 135.819 69.3303 135.802 69.3303 135.785H67.3303ZM67.3303 128.38V135.785H69.3303V128.38H67.3303ZM66.2146 127.264C66.8308 127.264 67.3303 127.764 67.3303 128.38H69.3303C69.3303 126.659 67.9354 125.264 66.2146 125.264V127.264ZM65.0993 128.354C65.1129 127.75 65.6072 127.264 66.2146 127.264V125.264C64.5177 125.264 63.1378 126.621 63.0998 128.309L65.0993 128.354ZM63.0995 126.794V128.331H65.0995V126.794H63.0995ZM61.9839 125.678C62.6 125.678 63.0995 126.178 63.0995 126.794H65.0995C65.0995 125.073 63.7046 123.678 61.9839 123.678V125.678ZM60.8682 126.794C60.8682 126.178 61.3677 125.678 61.9839 125.678V123.678C60.2631 123.678 58.8682 125.073 58.8682 126.794H60.8682ZM60.8682 129.967V126.794H58.8682V129.967H60.8682ZM59.8672 130.967H59.8682V128.967H59.8672V130.967ZM58.8672 125.206V129.967H60.8672V125.206H58.8672ZM57.7516 124.091C58.3677 124.091 58.8672 124.59 58.8672 125.206H60.8672C60.8672 123.486 59.4723 122.091 57.7516 122.091V124.091ZM56.6367 125.162C56.6595 124.567 57.1501 124.091 57.7516 124.091V122.091C56.0711 122.091 54.7017 123.421 54.6382 125.086L56.6367 125.162ZM54.6375 114.893V125.124H56.6375V114.893H54.6375ZM53.2573 113.513C54.0196 113.513 54.6375 114.131 54.6375 114.893H56.6375C56.6375 113.027 55.1241 111.513 53.2573 111.513V113.513Z",
    fill: "black",
    mask: "url(#path-40-outside-2_1645_810)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1645_810",
    x: 41.2319,
    y: 111.513,
    width: 32.0985,
    height: 45.9658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1645_810"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1645_810",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectProdcutSvg);
export default __webpack_public_path__ + "static/media/Select ProdcutSVG.8f4fbf58353f23361701bc921323597a.svg";
export { ForwardRef as ReactComponent };